import setNodesX, { clearX } from "./handlers/xPosition/setNodesX";
import setNodesY, { clearY } from "./handlers/setNodesY";

export default (model) => {
  clearY(model);
  clearX(model);
  setNodesY(model);
  setNodesX(model);
};
